import { createReducer, on } from '@ngrx/store';

import { isBlackKnight, isDataTrace } from '../../helpers/data-provider';
import { FormValidationErrors } from '../../typings/form-validation-errors';
import * as fromDataProviderActions from '../actions/data-provider.actions';
import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromSettingActions from '../actions/setting.actions';

export const dataProviderFeatureKey = 'dataProvider';

export interface State {
  id: string | null;
  isAuthenticated: boolean;
  isBlackKnight: boolean;
  isDataTrace: boolean;
  loginFormValidationErrors: FormValidationErrors;
  password: string | null;
  url: string | null;
  username: string | null;
}

export const initialState: State = {
  id: null,
  isAuthenticated: false,
  isBlackKnight: false,
  isDataTrace: false,
  loginFormValidationErrors: {},
  password: null,
  url: null,
  username: null
};

export const reducer = createReducer(
  initialState,
  on(
    fromSettingActions.loadSettingsSuccess,
    fromSettingActions.updateReferralCodeSuccess,
    fromPersistedStateActions.migratePersistedOldStateReferralCodeSuccess,
    (state, { payload }) => ({
      ...state,
      id: payload.data.provider.name,
      isBlackKnight: isBlackKnight(payload.data.provider.name),
      isDataTrace: isDataTrace(payload.data.provider.name),
      password: null,
      url: payload.data.provider.authAddress,
      username: null
    })
  ),
  on(fromSettingActions.refreshReferralCodeSuccess, (state, { payload }) => ({
    ...state,
    id: payload.data.provider.name,
    isBlackKnight: isBlackKnight(payload.data.provider.name),
    isDataTrace: isDataTrace(payload.data.provider.name),
    url: payload.data.provider.authAddress
  })),
  on(fromDataProviderActions.updateDataProviderAuthentication, (state, { payload }) => ({
    ...state,
    isAuthenticated: false,
    isBlackKnight: isBlackKnight(payload.data.provider.name),
    isDataTrace: isDataTrace(payload.data.provider.name),
    loginFormValidationErrors: {}
  })),
  on(
    fromDataProviderActions.authenticateDataProviderSuccess,
    fromPersistedStateActions.migratePersistedOldStateDataProviderCredentialsSuccess,
    (state, { payload }) => ({
      ...state,
      isAuthenticated: true,
      loginFormValidationErrors: {},
      password: payload.data.password,
      username: payload.data.username
    })
  ),
  on(fromDataProviderActions.authenticateDataProviderFailure, (state, { payload }) => ({
    ...state,
    loginFormValidationErrors: {
      password: {
        invalid: payload.error.message
      }
    }
  })),
  on(fromDataProviderActions.changePasswordSuccess, (state, { payload }) => ({
    ...state,
    password: payload.newPassword
  })),
  on(fromDataProviderActions.authenticateDataProviderPasswordExpired, (state, { payload }) => ({
    ...state,
    username: payload.username
  })),
  on(
    fromDataProviderActions.authenticateDataProviderReset,
    fromSettingActions.loadSettings,
    fromSettingActions.loadSettingsReset,
    fromPersistedStateActions.persistedStateReset,
    fromPersistedStateActions.loadPersistedStateFailure,
    () => ({
      ...initialState
    })
  ),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[dataProviderFeatureKey]
  }))
);
